<template>
    <div class="buttons-message">
        <div class="dot"></div>
        <div class="buttons-message__body">
            <p v-if="msg.content.text" class="buttons-text">{{ msg.content.text }}</p>
            <div class="buttons-options">
                <button v-for="option in msg.content.options" :key="option.value" class="button-option"
                    :class="{ selected: selectedLabel === option.label }" :disabled="disabled"
                    @click="$emit('select', msg.content.actionId, option.value, option.label)">
                    {{ option.label }}
                </button>
            </div>
            <HoverBar :date="msg.created_at || msg.content.created_at" :message-id="msg.id" />
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import HoverBar from '../ui/HoverBar.vue';

defineProps({
    msg: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    selectedLabel: { type: String, default: null }
});

defineEmits(['select']);
</script>

<style lang="scss" scoped>
.buttons-message {
    display: flex;
    gap: 10px;
    padding-left: 0;
    align-self: flex-start;
    width: fit-content;
    align-self: flex-start;
    max-width: 80%;

    .dot {
        min-width: 8px;
        min-height: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: var(--color-blue);
        margin-top: 6px;
        margin-right: 5px;
        margin-left: 5px;
        flex-shrink: 0;
    }

    :deep(.hover-bar) {
        padding-top: 5px;
    }

    &:hover :deep(.hover-bar) {
        opacity: 1;
        pointer-events: auto;
    }

    .buttons-text {
        margin: 0 0 10px 0;
        color: var(--color-text);
    }

    .buttons-options {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .button-option {
        padding: 8px 16px;
        border: 1px solid var(--color-border);
        border-radius: 8px;
        background-color: var(--color-bg-dark);
        color: var(--color-text);
        cursor: pointer;
        transition: all 0.2s;
        font-size: 14px;

        &:hover:not(:disabled) {
            background-color: var(--color-blue);
            color: white;
            border-color: var(--color-blue);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        &.selected {
            background-color: var(--color-blue);
            color: white;
            border-color: var(--color-blue);
            opacity: 1;
        }
    }
}
</style>
